"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const provider_components_1 = require("@kyruus/provider-components");
const styles_1 = require("./styles");
/**
 * Method to create an array of JSX icons.
 * @param {Component} Icon The Icon to populate the array.
 * @param {number} num The desired length of the icon array.
 * @param {size} num The desired size of the icon.
 * @return {JSX[]} An array with all the icons.
 */
const iconArrayCreator = (Icon, num, size) => {
    const icons = [];
    for (let i = 0; i < num; i++) {
        icons.push(react_1.default.createElement(Icon, { size: `${size}px`, key: `${Icon.displayName}-${i}`, "aria-hidden": true }));
    }
    return icons;
};
const StarRating = ({ rating, starSize, widthAccuracyCorrection }) => {
    // Get the rating scale
    const ratingScale = provider_components_1.DEFAULTS.PROVIDER_RATING_SCALE;
    const filledPercent = `${rating / (0.01 * ratingScale)}%`;
    return (react_1.default.createElement(styles_1.SummaryStars, { "aria-hidden": true, 
        //@ts-ignore: non-intrinsic attributes for emotion styling
        ratingScale: ratingScale, starSize: starSize, widthAccuracyCorrection: widthAccuracyCorrection },
        react_1.default.createElement(styles_1.StarWrapper, null,
            react_1.default.createElement(styles_1.EmptyStars, null, iconArrayCreator(styles_1.StyledStarOutline, ratingScale, starSize)),
            react_1.default.createElement(styles_1.FilledStars
            //@ts-ignore: non-intrinsic attributes for emotion styling
            , { 
                //@ts-ignore: non-intrinsic attributes for emotion styling
                filledPercent: filledPercent }, iconArrayCreator(styles_1.StyledStar, ratingScale, starSize)))));
};
exports.default = (0, intl_1.injectIntl)(StarRating);
//# sourceMappingURL=star-rating.js.map